<form>
  <label class="d-block k-label">
    Element (right click to select)
    <help-element-picker
      class="w-100"
      [formField]="f.element"
    ></help-element-picker>
  </label>
  <label class="d-block k-label">
    Title
    <input class="w-100 k-textbox" [formField]="f.title" />
  </label>
  <label class="d-block k-label">
    Content
    <kendo-editor
      help-anchor="body"
      [value]="model().body"
      (valueChange)="setBody($event)"
    ></kendo-editor>
  </label>
  <div class="d-flex justify-content-end">
    <button
      kendoButton
      [primary]="true"
      [disabled]="!f().valid()"
      (click)="complete.emit()"
    >
      Complete
    </button>
  </div>
</form>
